export const DEFAULT_OG_IMAGE_URL =
  'https://d17th0s7i8wl11.cloudfront.net/SE_Thumbnail_5d5cb9e21b.png';

export const DEFAULT_OG_IMAGE = {
  url: DEFAULT_OG_IMAGE_URL,
  alt: 'StartEngine',
  width: 1920,
  height: 1080,
  type: 'image/png',
};

export const DEFAULT_TWITTER_IMAGE = DEFAULT_OG_IMAGE_URL;
